import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store';

export enum THEME {
  LITHE = 'light',
  DARK = 'dark',
}
export interface ILayout {
  collapsed: boolean;
  theme: THEME;
  key: {
    key: string;
    label: string;
  };
}

const initialState: ILayout = {
  collapsed: false,
  theme: THEME.LITHE,
  key: {
    key: '1',
    label: 'dashboard',
  },
};

export const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setCollapsed: (state, action) => {
      state.collapsed = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    setSelectedMenuKey: (state, action) => {
      state.key = action.payload;
    },
  },
});

export const { setCollapsed, setTheme, setSelectedMenuKey } =
  layoutSlice.actions;

export const selectLayout = (state: RootState) => state.layout;
